(function () {
  if (window.__socialSignalInit) return;
  window.__socialSignalInit = true;

  function render(el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 0;
    var max = parseInt(el.getAttribute('data-max'), 10) || 0;
    if (max < min) {
      var swap = min;
      min = max;
      max = swap;
    }
    var n = Math.floor(Math.random() * (max - min + 1)) + min;
    var tmpl = el.getAttribute('data-template') || '';
    var node = el.querySelector('[data-social-signal-text]');
    if (node) node.textContent = tmpl.replace('{count}', n);
  }

  function init() {
    var blocks = document.querySelectorAll('[data-social-signal]');
    for (var i = 0; i < blocks.length; i++) render(blocks[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
